import { type ReactNode } from 'react';
import { FOUNDERS_TOTAL } from '../founders-config';

export function FoundersHero(): ReactNode {
  return (
    <header className="space-y-sm">
      <h1 className="font-display text-3xl font-bold leading-none tracking-tight text-white sm:text-4xl">
        Pioneros <span className="text-brand-red">Fundadores</span>
      </h1>
      <p className="max-w-[40rem] text-sm leading-relaxed text-text-secondary">
        Los {FOUNDERS_TOTAL.toLocaleString('es-ES')} creadores seleccionados
        para colaborar con Debook. Sus identidades se revelarán cuando llegue el
        momento.
      </p>
    </header>
  );
}
